module.exports = __webpack_public_path__ + "img/LG_horizontal-yellow-shape-progression.06649af7.png";